import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import storage from '@/utils/storage';
import { useScreenSize } from '@/hooks';
import AffiliateRules from './components/AffiliateRules';
import AffiliateDashboard from './components/AffiliateDashboard';
import AffiliateRewards from './components/AffiliateRewards';
import styles from './Affiliate.module.css';

/**
 * Affiliate Page Component
 * Main container for affiliate program with navigation tabs
 */
const Affiliate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isMobile } = useScreenSize();
  const [isLogged, setIsLogged] = useState(false);

  // Check if user is logged in - only run once on mount
  useEffect(() => {
    const token = storage.getKey('token');
    setIsLogged(!!token);
  }, []); // Empty dependency array - only run once

  const navItemLinks = [
    {
      id: 1,
      name: 'Dashboard',
      route: '/affiliate',
    },
    {
      id: 2,
      name: 'My Rewards',
      route: '/affiliate/my-rewards',
    },
    {
      id: 4,
      name: 'Rate & Rules',
      route: '/affiliate/rules',
    },
  ];

  const getRandomAmount = () => {
    const min = 0.15;
    const max = 60.0;
    const amount = (Math.random() * (max - min) + min).toFixed(2);
    return `$${amount}`;
  };

  const liveRewardsData = [
    { name: 'Antony Roberts', amount: getRandomAmount() },
    { name: 'Aarav Verma', amount: getRandomAmount() },
    { name: 'সিয়া রাওয়াত', amount: getRandomAmount() },
    { name: 'Sofia Hernández', amount: getRandomAmount() },
    { name: 'Vivaan Desai', amount: getRandomAmount() },
    { name: 'Li Wei', amount: getRandomAmount() },
    { name: 'Siya Rawat', amount: getRandomAmount() },
    { name: 'محمد علي', amount: getRandomAmount() },
    { name: 'Daisuke Tanaka', amount: getRandomAmount() },
    { name: 'Emma Johnson', amount: getRandomAmount() },
    { name: 'Carlos Romero', amount: getRandomAmount() },
    { name: '张伟', amount: getRandomAmount() },
    { name: 'Meera Iyer', amount: getRandomAmount() },
    { name: 'Riya Sharma', amount: getRandomAmount() },
    { name: 'Johannes Müller', amount: getRandomAmount() },
    { name: 'Aditi Patel', amount: getRandomAmount() },
    { name: 'Jithin Kumar', amount: getRandomAmount() },
    { name: 'Olivia Smith', amount: getRandomAmount() },
    { name: 'Mohammed Ali', amount: getRandomAmount() },
    { name: 'Tariq Abdullah', amount: getRandomAmount() },
    { name: 'Miguel Oliveira', amount: getRandomAmount() },
    { name: 'Yuki Nakajima', amount: getRandomAmount() },
    { name: 'Nina Popov', amount: getRandomAmount() },
    { name: 'Lucía Martín', amount: getRandomAmount() },
    { name: 'Ayaan Sheikh', amount: getRandomAmount() },
    { name: 'Marie Dubois', amount: getRandomAmount() },
    { name: 'ソフィア・ヘルナンデス', amount: getRandomAmount() },
    { name: '李伟', amount: getRandomAmount() },
    { name: '田中大輔', amount: getRandomAmount() },
    { name: 'मीरा अय्यर', amount: getRandomAmount() },
    { name: 'अदिति पटेल', amount: getRandomAmount() },
    { name: 'ゆき なかじま', amount: getRandomAmount() },
    { name: 'Нина Попов', amount: getRandomAmount() },
    { name: 'আয়ান শেখ', amount: getRandomAmount() },
    { name: 'चरणजीत सिंह', amount: getRandomAmount() },
    { name: 'Ananya Chakraborty', amount: getRandomAmount() },
    { name: '한미영', amount: getRandomAmount() },
    { name: 'Владимир Иванов', amount: getRandomAmount() },
    { name: 'İsmail Yıldırım', amount: getRandomAmount() },
    { name: 'Αλέξανδρος Δημητρίου', amount: getRandomAmount() },
    { name: 'Elena Rossi', amount: getRandomAmount() },
    { name: 'Fatima Zahra', amount: getRandomAmount() },
    { name: 'Joaquín Morales', amount: getRandomAmount() },
    { name: 'Chantal Dupont', amount: getRandomAmount() },
    { name: 'Sara Mehta', amount: getRandomAmount() },
  ];

  const currentPath = location.pathname;
  const isActiveRoute = (route) => {
    if (route === '/affiliate') {
      return currentPath === '/affiliate' || currentPath === '/affiliate/';
    }
    return currentPath === route || currentPath.startsWith(route + '/');
  };

  const handleSignUp = () => {
    navigate('/login');
  };

  return (
    <div className={styles.wrapper}>
      {isLogged && (
        <div className={styles.navWrapper}>
          <h1 className={styles.title}>Affiliate</h1>
          <div className={styles.navContainer}>
            <ul className={styles.nav}>
              {navItemLinks.map((item) => (
                <li key={item.id} className={styles.navItem}>
                  <button
                    className={`${styles.navLink} ${isActiveRoute(item.route) ? styles.active : ''}`}
                    onClick={() => navigate(item.route)}
                  >
                    <span>{item.name}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {isLogged ? (
        <>
          {currentPath === '/affiliate' || currentPath === '/affiliate/' ? (
            <AffiliateDashboard />
          ) : currentPath === '/affiliate/my-rewards' ? (
            <AffiliateRewards />
          ) : currentPath === '/affiliate/rules' ? (
            <AffiliateRules />
          ) : (
            <AffiliateDashboard />
          )}
        </>
      ) : (
        <>
          <div className={styles.signUpBanner}>
            <div className={styles.signUpBannerText}>
              <h1 className={styles.bannerTitle}>Invite Friends to Earn</h1>
              <p className={styles.bannerSubTitle}>$300.00 + 15% Commission</p>
              <button className={styles.signUpBtn} onClick={handleSignUp}>
                Sign up & Earn
              </button>
            </div>
          </div>

          <div className={styles.bodyWrapper}>
            <div className={styles.sectionContentBody}>
              <div className={styles.sectionHeader}>
                <div className={styles.indicator}></div>
                <h2 className={styles.sectionTitle}>Live Rewards</h2>
              </div>

              <div className={styles.liveRewardsContainer}>
                <div className={styles.totalRewardBox}>
                  <div className={styles.totalRewardLabel}>Total Reward Sent To-Date</div>
                  <div className={styles.totalRewardAmount}>$280820.08</div>
                </div>

                <div className={styles.scrollingWrapper}>
                  <div className={styles.scrollingContent}>
                    {liveRewardsData.concat(liveRewardsData).map((item, index) => (
                      <div key={index} className={styles.rewardItem}>
                        {item.name} <span className={styles.rewardAmount}>{item.amount}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Affiliate;
